import {get, isEmpty, isNil, isString, set} from 'lodash';
import {Employee, EMPLOYEETABLECOLUMNS, getPvdType} from 'src/app/views/wrapper/payroll/employee/employee';
import {IsEmptyValue, MinDateTime, replaceRN, replaceStringMinus, replaceUnicode} from './utils';
import {replaceAddressSynonymForEmployee} from './utils-address';
import {synonymAddressForEmployee} from './utils-interface';

const AddressFields = ['street_no', 'moo_no', 'building', 'room_no', 'floor_no', 'village_name', 'soi', 'alley', 'lane', 'road', 'sub_district', 'district', 'province', 'postal_code'];
const AddressRequiredFields = ['street_no', 'sub_district', 'district', 'province', 'postal_code'];

export const DecorateEmployeeData = (
  data: any,
  employeeColumns: EMPLOYEETABLECOLUMNS[],
  isAdded = false,
  oldDatas: any = null,
  isAddress = false,
  requiredDatas = [],
  employmentIdList = [],
  idCardList = [],
  emailList = []
) => {
  const newData = [];
  let isRequired = true;
  data.forEach((row, rowIndex) => {
    const obj: any = {};
    const objOld: any = {};
    let isRequiredData = true;
    row.forEach((item, index) => {
      if (isString(item) && !IsEmptyValue(item)) {
        item = replaceRN(replaceUnicode(item)).trim();
        if (item.trim() === '-') {
          item = replaceStringMinus(item.trim());
        }
      }
      if (employeeColumns[index].type === 'numeric' && !employeeColumns[index].showString) {
        const num = item?.toString().replaceAll(',', '');
        item = num ? parseFloat(num) : null;
      } else if (employeeColumns[index].type === 'calendar') {
        item = getDateOnPaste(item);
        item = item.slice(0, 10); // Show only date
      } else if (employeeColumns[index].type === 'dropdown') {
        item = item.toLowerCase() === 'null' ? null : item;
      }
      item = ReplaceAddressSynonymValue(item, employeeColumns[index].name);

      let prerequisiteRequired = false;
      if (employeeColumns[index].prerequisite) {
        const preIndex = employeeColumns.findIndex(d => d.name === employeeColumns[index].prerequisite);
        if (preIndex > -1) {
          if (IsEmptyValue(row[preIndex])) {
            item = null;
          } else if (IsEmptyValue(item)) {
            prerequisiteRequired = true;
            const prerequisiteCol = {
              row: rowIndex,
              col: index,
              fields: employeeColumns[index].name,
              style: {required: true}
            }
            if (!requiredDatas) {
              requiredDatas = []
            }
            requiredDatas.push(prerequisiteCol);
          }
        }
      }

      if ((employeeColumns[index].validate && !employeeColumns[index].validate(item)) ||
        prerequisiteRequired ||
        (employeeColumns[index].required && !employeeColumns[index].allowEmpty && IsEmptyValue(item))) {
        isRequiredData = false;
      }

      if (employeeColumns[index].name === 'bank_account') {
        if (validBankAccount(row[index - 1], item)) {
          isRequiredData = false;
          employeeColumns[index - 1].required = true;
          employeeColumns[index - 1].allowEmpty = false;
        } else {
          employeeColumns[index - 1].allowEmpty = true;
        }
      }

      if (employeeColumns[index].name === 'provident_fund') {
        let pvdTypeIndex = employeeColumns.findIndex(d=> d.name === 'provident_fund_type');
        if (getPvdType(row[pvdTypeIndex]) === 'percentage') {
          set(obj, 'provident_fund_percentage', item);
          item = null;
        } else {
          set(obj, 'provident_fund_percentage', null);
        }
      }

      if (employeeColumns[index].name === 'provident_fund_type') {
        let pvdIndex = employeeColumns.findIndex(d=> d.name === 'provident_fund');
        let typeID = getPvdType(item)
        if (IsEmptyValue(row[pvdIndex]) || !typeID) {
          set(obj, 'provident_fund_percentage', null);
          set(obj, 'provident_fund', null);
          item = null;
        } else {
          item = typeID
        }
      }

      if (employeeColumns[index].name === 'provident_fund_employer') {
        let pvdTypeIndex = employeeColumns.findIndex(d=> d.name === 'provident_fund_employer_type');
        if (getPvdType(row[pvdTypeIndex]) === 'percentage') {
          set(obj, 'provident_fund_employer_percentage', item);
          item = null;
        } else {
          set(obj, 'provident_fund_employer_percentage', null);
        }
      }

      if (employeeColumns[index].name === 'provident_fund_employer_type') {
        let pvdIndex = employeeColumns.findIndex(d=> d.name === 'provident_fund_employer');
        let typeID = getPvdType(item)
        if (IsEmptyValue(row[pvdIndex]) || !typeID) {
          set(obj, 'provident_fund_employer_percentage', null);
          set(obj, 'provident_fund_employer', null);
          item = null;
        } else {
          item = typeID
        }
      }

      if ((employeeColumns[index].name === 'employment_id' || employeeColumns[index].name === 'id_card' || employeeColumns[index].name === 'personal_email')
          && !IsEmptyValue(item))
      {
        let list = employmentIdList;
        if (employeeColumns[index].name === 'id_card') {
          list = idCardList;
        } else if (employeeColumns[index].name === 'personal_email') {
          list = emailList;
        }
        
        if (isAdded) {
          if (list.includes(item)) {
            isRequiredData = false;
          }
        } else {
          if (list.find(i => i[employeeColumns[index].name] === item && i.id !== row[row.length - 1])) {
            isRequiredData = false;
          }
        }
      }

      set(obj, employeeColumns[index].name, item);
      if (oldDatas) {
        set(objOld, employeeColumns[index].name, oldDatas[rowIndex][index]);
      }
    });
    if (isAdded || isAddress) {
      const objResult = validAddressDetails(isAdded, row, employeeColumns, isRequiredData, rowIndex, requiredDatas);
      isRequiredData = objResult.isRequiredData;
      requiredDatas = objResult.requiredDatas;
    }
    // validate required fields background changed
    if (!IsEmptyRow(obj, employeeColumns) || (oldDatas && !IsEmptyRow(objOld, employeeColumns))) {
      isRequired = isRequired && isRequiredData;
      newData.push(obj);
      employeeColumns.map((item, index) => {
        requiredDatas = findRequiredFields(
          employeeColumns, index, row[index], rowIndex, requiredDatas, isAddress, employmentIdList, isAdded, row, data, idCardList
        );
      });
    }
  });
  return {isRequired, data: newData, requiredDatas};
};

export const findRequiredFields = (employeeColumns, index, item, rowIndex, requiredDatas, isAddress, employmentIdList = [], isAdded, row = null, data = null, idCardList = []) => {
  if (employeeColumns[index].name === 'employment_id' || employeeColumns[index].name === 'id_card') { // validate employee id and id card
    const list = employeeColumns[index].name === 'employment_id' ? employmentIdList : idCardList;
    if (isAdded) {
      if (!IsEmptyValue(item) && list.length > 0 && list.includes(item)) {
        requiredDatas = [...requiredDatas, {
          row: rowIndex,
          col: index,
          fields: employeeColumns[index].name,
          style: {required: true}
        }];
      } else if (requiredDatas.find(i => i.row === rowIndex && i.col === index)) {
        requiredDatas = requiredDatas.map(i => i.row === rowIndex && i.col === index ? {
          ...i,
          style: {...i.style, required: false}
        } : {...i});
      }
    } else { // edit employee
      if (row && data) {
        requiredDatas = requiredDatas.map(i => i.row === rowIndex && i.col === index ? {
          ...i,
          style: {...i.style, required: false}
        } : {...i});
        if (list.find(i => i[employeeColumns[index].name] === item && i.id !== row[row.length - 1])) {
          data.map((_, key) => {
            if (data[key][index] === item) {
              if (!requiredDatas.find(i => i.row === key && i.col === index)) {
                requiredDatas = [...requiredDatas, {
                  row: key,
                  col: index,
                  fields: employeeColumns[index].name,
                  style: {required: true}
                }];
              } else {
                requiredDatas = requiredDatas.map(i => i.row === key && i.col === index ? {
                  ...i,
                  style: {...i.style, required: list.filter(j => j[employeeColumns[index].name] === item).length > 0}
                } : {...i});
              }
            }
          });
        }
      }
    }
  } else {
    if (employeeColumns[index].required && !employeeColumns[index].allowEmpty && IsEmptyValue(item)) {
      if (!requiredDatas.find(i => i.row === rowIndex && i.col === index)) {
        requiredDatas = [...requiredDatas, {
          row: rowIndex,
          col: index,
          fields: employeeColumns[index].name,
          style: {required: true}
        }];
      }
    } else if (employeeColumns[index].required && !employeeColumns[index].allowEmpty && !IsEmptyValue(item) &&
      (requiredDatas.find(i => i.row === rowIndex && i.col === index))
    ) {
      requiredDatas = requiredDatas.map(i => i.row === rowIndex && i.col === index ? {
        ...i,
        style: {...i.style, required: false}
      } : {...i});
    } else if (employeeColumns[index].required && employeeColumns[index].allowEmpty &&
      (requiredDatas.find(i => i.row === rowIndex && i.col === index))
    ) {
      requiredDatas = requiredDatas.map(i => i.row === rowIndex && i.col === index ? {
        ...i,
        style: {...i.style, required: false}
      } : {...i});
    } else if (isAddress) {
      AddressRequiredFields.map(address => {
        requiredDatas = !requiredDatas.find(i => i.row === rowIndex && i.col === employeeColumns.findIndex(col => col.name.includes(`.${address}`))) &&
        IsEmptyValue(row[employeeColumns.findIndex(col => col.name.includes(`.${address}`))]) ?
          [...requiredDatas, {
            row: rowIndex,
            col: employeeColumns.findIndex(col => col.name.includes(`.${address}`)),
            fields: address,
            style: {required: true}
          }] : requiredDatas.map(i => i.row === rowIndex && i.col === index ? {
            ...i,
            style: {...i.style, required: IsEmptyValue(item)}
          } : {...i});
      });
    }
  }
  return requiredDatas;
};

export const validAddressDetails = (isAdded, row, employeeColumns, isRequiredData, rowIndex, requiredDatas) => {
  row.forEach((item, index) => {
    const name = employeeColumns[index].name.split('.');
    if (name.length > 1 && AddressFields.includes(name[1])) {
      const addressIndex = employeeColumns.findIndex(i => i.name === employeeColumns[index].name);
      if ((row[addressIndex] && row[addressIndex] !== '') &&
        AddressRequiredFields.some(add =>
          row[employeeColumns.findIndex(i => add === i.name.split('.')[1])].trim() === '' ||
          row[employeeColumns.findIndex(i => add === i.name.split('.')[1])].trim() === '-'
        )) {
        isRequiredData = false;
        requiredDatas = findRequiredFields(employeeColumns, index, item, rowIndex, requiredDatas, true, [], isAdded, row, null);
      }
    }
  });
  return {isRequiredData, requiredDatas};
};

export const validBankAccount = (selectedBank, value) => {
  // check length = 10
  let flag = false;
  if (value !== '' && value.length < 10) {
    flag = true;
  }
  // has bank name selected
  if (value !== '' && (!selectedBank || selectedBank === '')) {
    flag = true;
  }
  return flag;
};

export const getDateOnPaste = (dateS: string) => {
  let date = '';
  if (dateS) {
    if (dateS.length > 11) {
      // Support copy date cell to another date cell
      const nDate = new Date(dateS);
      if (!isNaN(nDate.getTime()) && nDate.getTime() > MinDateTime) {
        dateS = `${nDate.getDate()}/${nDate.getMonth() + 1}/${nDate.getFullYear()}`;
      }
    }

    const delimeters = ['/', '-', ' '];
    delimeters.forEach(delimeter => {
      const dateSplitted = dateS.split(delimeter);
      if (dateSplitted.length === 3) {
        if (dateSplitted[0].length > 2) { // YYYY-MM-DD
          date = getNewDateValue(dateSplitted[2], dateSplitted[1], dateSplitted[0]);
        } else {
          date = getNewDateValue(dateSplitted[0], dateSplitted[1], dateSplitted[2]);
        }
        if (!isNaN(new Date(date).getTime()) && new Date(date).getTime() > MinDateTime) {
          return;
        } else {
          date = '';
        }
      }
    });
  }
  return date;
};

export const getNumberOnPasteRemoveMinus = (value: string) => {
  const search = '-';
  const searchRegExp = new RegExp(search, 'g'); // Throws SyntaxError
  const replaceWith = '';
  return value.replace(searchRegExp, replaceWith);
};

export const getNewDateValue = (d: string, m: string, y: string) => {
  const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const mIndex = months.indexOf(m.toLowerCase());
  if (mIndex > -1) {
    m = (mIndex + 1).toString();
  }

  if (parseInt(y, 10) > 2300) {
    y = (parseInt(y, 10) - 543).toString();
  }
  return formatDate(d, m, y);
};

export const formatDate = (d: string, m: string, y: string): string => {
  const mm = parseInt(m, 10) < 10 ? `0${parseInt(m, 10)}` : m;
  const dd = parseInt(d, 10) < 10 ? `0${parseInt(d, 10)}` : d;
  return `${y}-${mm}-${dd}`;
};

export const ReplaceAddressSynonymValue = (value: any, name: string) => {
  const list = Object.keys(synonymAddressForEmployee);
  const key = name.replace('id_card_address.', '').replace('contact_address.', '');
  if (list.includes(key)) {
    return replaceAddressSynonymForEmployee(key, value);
  }
  return value;
};

export const IsEmptyRow = (employee: Employee, employeeColumns: EMPLOYEETABLECOLUMNS[]): boolean => {
  return employeeColumns.every((col) => {
    const val = get(employee, col.name);
    return isNil(val) || isEmpty(val) || val === col.defaultValue;
  });
};

export const validateID = (id) => {
  if (id.length !== 13) {
    return false;
  }
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseFloat(id.charAt(i)) * (13 - i);
  }
  return (11 - sum % 11) % 10 === parseFloat(id.charAt(12));

};

export const validateSsoIdCard = (id) => {
  return !id || id.length === 10 || id.length === 13;
};

export const validateBankAccount = (id) => {
  return !(!id || id.length !== 10);
};

export const getFirstLetter = (value) => {
  const except = ['เ', 'ใ', 'ไ', 'โ', 'แ'];
  let i = 0;
  while (except.indexOf(value?.charAt(i)) > -1) {
    i++;
  }
  return value?.charAt(i).toUpperCase();
};

export const getFullName = (item) => {
  return item?.first_name + ' ' + item?.last_name + (item?.nickname ? ' (' + item.nickname + ')' : '');
};

export const isSingleStatus = (status) => {
  return status === 'โสด';
};

export enum EmploymentType {
  FULL_TIME = 'พนักงานประจำ',
  PART_TIME = 'Part-time',
  OWNER = 'เจ้าของ',
}

export const isPartTime = (employment_type) => {
  return employment_type === EmploymentType.PART_TIME
}

export const isFullTime = (employment_type) => {
  return employment_type === EmploymentType.FULL_TIME;
}

export const getEmploymentTypeLabel = (employment_type): string => {
  switch (employment_type) {
    case EmploymentType.FULL_TIME:
      return 'Full-time'
    case EmploymentType.PART_TIME:
      return 'Part-time'
    case EmploymentType.OWNER:
      return 'Owner'
    default:
      return employment_type
  }
}

export const getEmploymentTypeColor = (employment_type): string => {
  switch (employment_type) {
    case EmploymentType.FULL_TIME:
      return '#d0f7d7'
    case EmploymentType.PART_TIME:
      return '#fcdfaf'
    case EmploymentType.OWNER:
      return '#d1e8ff'
    default:
      return '#dae5df'
  }
}

export const isSSOAgeValid = (birthDateStr: string, startDateStr: string): boolean => {
  if (birthDateStr && startDateStr) {
    const birthDate = new Date(new Date(birthDateStr).setHours(0,0,0,0))
    const startDate = new Date(new Date(startDateStr).setHours(0,0,0,0))
    let age15 = new Date(new Date(birthDate).setFullYear(birthDate.getFullYear() + 15))
    let age60 = new Date(new Date(birthDate).setFullYear(birthDate.getFullYear() + 60))
    return (startDate >= age15 && startDate <= age60)
  }
  return true
}

export function ssoAndBankChecker(data: any): any {
  return data.map(item => {
    // check sso
    let tempItem = {...item};
    if (item.sso_id_card !== '' && item.sso_start_date === '') {
      tempItem = {
        ...tempItem,
        sso_id_card: '',
        sso_start_date: null
      };
    } else if (item.sso_id_card === '' && item.sso_start_date !== '') {
      tempItem = {
        ...tempItem,
        sso_id_card: item.id_card,
        sso_start_date: item.sso_start_date
      };
    } else {
      tempItem = {...tempItem};
    }
    // check bank
    if (item.bank_id !== '' && item.bank_account === '') {
      tempItem = {
        ...tempItem,
        bank_id: ''
      };
    }
    return {...tempItem};
  });
}
